import { Injectable } from "@angular/core";
import { WebApiClient } from "../../web-api-client.service";
import { WebApiService } from "../../web-api.service";
import { RxOpt } from "./hist-edit-option";

@Injectable({ providedIn: 'root' })
export class ChiHistApi {
  apiService: WebApiService;
  /**
   *
   */
  constructor(private apiClient: WebApiClient) {
    this.apiService = this.apiClient.createChineseService('opd');
  }
  
  async GetChiRxOptions(): Promise<RxOpt[]> {
    return await this.apiService.get('GetChiRxOptions').toPromise<RxOpt[]>();
  }
  
  async AIGetReasonDx(cc:string): Promise<{Code:string,CName:string}[]> {
    return await this.apiService.post('AIGetReasonDx',{
      Content:cc
    }).toPromise();
  }
  async GetSTCMSingle():Promise<string[]>{
    return await this.apiService.get('GetSTCMSingle').toPromise();
  }
}
